import UiElement from '../../../shared/ui-element/ui-element';

import './toggle.scss';


class Toggle extends UiElement {
  activeOption?: HTMLButtonElement;

  ui = {
    'slider': '.js-toggle-slider',
  };

  uiCollections = {
    'options': '.js-toggle-option',
  }

  events = {
    'click @uiCollections.options': 'handleToggleOptionClick',
  };

  toggleOptionActiveClass = 'toggle__option_active';

  onInit() {
    super.onInit();

    const options = this.uiCollections.options as unknown as HTMLButtonElement[];

    if (!options.length) {
      throw new Error('Toggle element has no options inside');
    }

    this.activeOption = options[0]!;
    this.moveSliderToOption(this.activeOption);

    window.addEventListener('resize', () => {
      this.moveSliderToOption(this.activeOption!);
    });
  }

  handleToggleOptionClick({ target }) {
    if (this.activeOption === target) return;

    this.activeOption!.classList.remove(this.toggleOptionActiveClass);
    this.moveSliderToOption(target);
    target.classList.add(this.toggleOptionActiveClass);
    this.activeOption = target;
  }

  moveSliderToOption(option: HTMLButtonElement) {
    const slider = this.ui.slider as unknown as HTMLElement;
    slider.style.width = `${option.clientWidth}px`;
    slider.style.left = `${option.offsetLeft}px`;
  }
}

export default Toggle as UiElement;
